export default __webpack_public_path__ + "static/media/verification page hive.7700dcce.svg";